import styled from 'styled-components';

import { ButtonConfirm } from '../../../../components/ButtonConfirm';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100%;

  display: flex;
  flex-direction: column;
  gap: 32px;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
  margin-bottom: 4px;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${colors.onSurfaceVariant};
  max-width: 620px;
`;

export const AppSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const AppSectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const AppSectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const AppSectionTag = styled.span`
  padding: 2px 10px;
  border-radius: ${radius.full};
  background-color: ${colors.surfaceContainer};

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.onSurfaceVariant};
`;

export const PlatformGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Panel = styled.div`
  padding: 24px;
  border-radius: ${radius.md};
  background-color: ${colors.surfaceContainerLow};

  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PanelTitle = styled.h3`
  font-size: 15px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const PanelBadge = styled.span<{ tone: 'ok' | 'warning' }>`
  margin-left: auto;
  padding: 3px 10px;
  border-radius: ${radius.full};

  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  background-color: ${({ tone }) =>
    tone === 'ok' ? `${colors.success}1f` : `${colors.error}1f`};
  color: ${({ tone }) => (tone === 'ok' ? colors.success : colors.error)};
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const FieldLabel = styled.label`
  font-size: 11px;
  font-weight: 700;
  color: ${colors.onSurfaceVariant};
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const TextInput = styled.input`
  height: 42px;
  padding: 0 14px;

  background-color: ${colors.surfaceContainer};
  border: none;
  border-radius: ${radius.DEFAULT};

  font-size: 13px;
  color: ${colors.onSurface};

  &::placeholder {
    color: ${colors.onSurfaceVariant};
  }
`;

export const LinkInputRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const TestLinkButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 42px;
  height: 42px;
  border: none;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;

  background-color: ${colors.surfaceContainer};
  color: ${colors.onSurfaceVariant};

  transition: color 0.15s, background-color 0.15s;

  &:hover:not(:disabled) {
    background-color: ${colors.surfaceContainerHigh};
    color: ${colors.primary};
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

export const PanelFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const UpdatedAtLabel = styled.span`
  font-size: 11px;
  color: ${colors.onSurfaceVariant};
`;

export const SaveButton = styled(ButtonConfirm)`
  width: auto;
  height: 38px;
  padding: 0 18px;
  border-radius: ${radius.DEFAULT};
`;
